const StudyField = ({ value, onChange, error }) => {
  const handleInputChange = (e) => {
    const inputValue = e.target.value;

    // Replace suffixes with superscripts
    const formattedValue = inputValue.replace(
      /\b(\d+)(st|nd|rd|th|ST|ND|RD|TH)\b/g,
      (match, number, suffix) => {
        const superscripts = {
          st: "ˢᵗ",
          nd: "ⁿᵈ",
          rd: "ʳᵈ",
          th: "ᵗʰ",
          ST: "ˢᵀ",
          ND: "ᴺᴰ",
          RD: "ᴿᴰ",
          TH: "ᵀᴴ",
        };
        return `${number}${superscripts[suffix] || suffix}`;
      }
    );

    // Notify the parent of the change
    onChange({ target: { name: "study1", value: formattedValue } });
  };

  return (
     <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "0px",
        maxWidth: "100%",
      }}
    >
	<label
        htmlFor="study1"
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          flexWrap: "wrap",
        }}
      >
      
        <select
  name="selection2"
  value={value.selection2 || ""}
  onChange={onChange}
  style={{
    flex: "1",
    minWidth: "50px",
    padding: "10px",
    borderRadius: "8px",
    border: "1px solid #81c784", // Green border
    fontSize: "1rem",
    background: "linear-gradient(135deg, #e8f5e9, #a5d6a7)", // Green gradient
    color: "#388e3c", // Green font color

    // ❌ Removed to show default dropdown arrow:
    // appearance: "none",
    // WebkitAppearance: "none",
    // MozAppearance: "none",

    boxShadow: "0px 4px 8px rgba(129, 199, 132, 0.4)", // Light green shadow
    transition: "background-color 0.3s ease",
    cursor: "pointer",
  }}
>
  <option value="Study">Study</option>
  <option value="Class">Class</option>
  <option value="Course">Course</option>
  <option value="Grade">Grade</option>
  {/*<option value="Standard">Standard</option>*/}
</select>


        <input
          type="text"
          name="study1"
          value={value.study1 || ""}
          onChange={handleInputChange}
          placeholder="Ex: 2nd Class Sec: A"
          style={{
            flex: "2",
            minWidth: "100px",
            padding: "10px",
            borderRadius: "4px",
            border: "1px solid #ccc",
            fontSize: "1rem",
            boxSizing: "border-box",
          }}
        />
      </label>
      {error && <div style={{ color: "red", fontSize: "12px" }}>{error}</div>}
    </div>
  );
};

export default StudyField;
